import fetchQuery from 'rebook/apps/utils/fetchQuery';
import {
  LANDING_BOOKSET_IDS,
  LANDING_LANDING_SET_DATA,
  LANDING_NICHE_SLUGS,
  LANDING_GENRE_SLUGS,
} from 'rebook/apps/landing/constants';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';


export function fetchInitialData() {
  return async(dispatch, getState) => {
    const { landing } = getState();
    let promises = [];

    dispatch(setSeoMeta());

    if (!landing.noveltyBookset || !landing.businessBookset || !landing.freeBooksBookset) {
      promises.push(dispatch(fetchLandingBooksets()));
    }
    if (!landing.latestBooksets) {
      promises.push(dispatch(fetchLatestBooksets()));
    }
    if (!landing.niches) {
      // We need to render main page even if niches api fail
      promises.push(dispatch(fetchNiches()));
    }
    if (!landing.genres) {
      promises.push(dispatch(fetchGenres()));
    }

    await (promises.length > 0 ? Promise.all(promises) : Promise.resolve(null));
  };
}

export function fetchNiches() {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const url = '/api/catalog/niches/';
    return (
      fetchQuery(url, { apiVersion: 3, headers: ssr.headers })
        .then(({ data }) => {
          const niches = data.objects.filter((niche) => (
            LANDING_NICHE_SLUGS.indexOf(niche.slug) >= 0
          ));
          dispatch(setData({ niches }));
        })
        .catch(({ data, resp, error }) => {
          Raven.captureMessage('failed to load niche list for landing due to server error', {
            level: 'error',
            extra: {
              status: resp ? resp.status : null,
              response: data,
              error,
            },
          });
        })
    );
  };
}

export function fetchGenres() {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const url = `/api/catalog/genres/?slug__in=${LANDING_GENRE_SLUGS.join()}`;
    return (
      fetchQuery(url, { apiVersion: 3, headers: ssr.headers })
        .then(({ data }) => dispatch(setData({ genres: data.objects })))
        .catch(({ data, resp, error }) => {
          Raven.captureMessage('failed to load genre list for landing due to server error', {
            level: 'error',
            extra: {
              status: resp ? resp.status : null,
              response: data,
              error,
            },
          });
        })
    );
  };
}

export function fetchLatestBooksets() {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const url = `/api/booksets/?limit=10&booklimit=0`;
    return await fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(({ data }) => {
        dispatch(setData({
          latestBooksets: data.objects,
        }));
      })
      .catch(({ data, resp, error }) => {
        Raven.captureMessage('failed to load latest booksets list for landing due to server error', {
          level: 'error',
          extra: {
            status: resp ? resp.status : null,
            response: data,
            error,
          },
        });
      });
  };
}

export function fetchLandingBooksets() {
  return async(dispatch, getState) => {
    // fetch the list of series objects that the book belongs to
    const { ssr } = getState();
    const booksetIds = Object.keys(LANDING_BOOKSET_IDS);
    const booksetListUrl = `/api/booksets/?id__in=${booksetIds.join()}&booklimit=10`;
    const landingBooksetList = await (
      fetchQuery(booksetListUrl, { apiVersion: 4, headers: ssr.headers })
        // separately fetch book list for every book series
        .then(({ data }) => {
          let booksets = {};
          data.objects.forEach((bookset) => {
            booksets[LANDING_BOOKSET_IDS[bookset.id]] = bookset;
          });
          return booksets;
        })
        .catch(({ data, resp, error }) => {
          Raven.captureMessage('failed to load bookset list for landing due to server error', {
            level: 'error',
            extra: {
              status: resp ? resp.status : null,
              response: data,
              error,
            },
          });
          return [];
        })
    );
    let booksets = {};
    await Promise.all(Object.keys(landingBooksetList).map(async(booksetName) => {
      let books;
      try {
        books = landingBooksetList[booksetName].books;
      }
      catch (error) {
        Raven.captureException();
      }
      // skip failed book requests and bookset without books
      if (books && books.length > 0) {
        booksets[booksetName] = {
          bookset: landingBooksetList[booksetName],
          books,
        };
      }
    }));

    dispatch(setData({
      noveltyBookset: booksets.novelty,
      businessBookset: booksets.business,
      freeBooksBookset: booksets.free,
      audioBookset: booksets.audio,
    }));
  };
}

export function setSeoMeta() {
  return (dispatch, getState) => {
    const { booksPerSubscriptionCounter } = getState();
    const canonicalUrl = `https://${BASE_HOST}/`;
    const title = `Электронная библиотека MyBook — ` +
    `читайте книги в онлайн библиотеке. Новинки и бестселлеры литературы в библиотеке электронных книг.`;
    const description = `В электронной библиотеке MyBook можно` +
      ` прочитать и послушать более ${booksPerSubscriptionCounter.total}` +
      ` электронных книг и аудиокниг. Для онлайн чтения доступны шедевры современной и классической литературы. ` +
      `Новинки и бестселлеры, отзывы, рекомендации, популярные авторы.`;

    dispatch(SeoActions.setData({
      canonicalUrl,
      title,
      description,
    }));
  };
}

export function setData(payload) {
  return {
    type: LANDING_LANDING_SET_DATA,
    payload,
  };
}
